export default __webpack_public_path__ + "static/media/debate_30.1a32fa80.JPG";